<template>
  <com-page>
    <com-search :columns="searchColumns" @search="handleSearch">
      <template>
        <el-button type="primary" @click="handleBatch">生成设备</el-button>
      </template>
    </com-search>
    <com-card class="mt-15px">
      <com-table class="mt-15px" :columns="columns" :api="api" ref="table">
        <template #operation="row">
          <div class="flex">
            <el-button type="primary" size="mini" @click="handleWatch(row.data)"
              >查看设备</el-button
            >
            <!-- <el-button type="danger" size="mini" @click="handleWatch(row.data)">删除</el-button> -->
          </div>
        </template>
        <template #createTime="row">
          {{ row.data.createTime | formatDate }}
        </template>
        <template #status="row">
          {{ row.data.status === 0 ? '未使用' : '已使用' }}
        </template>
      </com-table>
    </com-card>
    <the-add-batch @success="init" ref="addBatch"></the-add-batch>
  </com-page>
</template>

<script>
import { batchListApi } from '@/api/equ'
import theAddBatch from './components/the-add-batch'

export default {
  components: { theAddBatch },
  data() {
    return {
      api: batchListApi,
      searchColumns: [
        {
          label: '生产批次',
          type: 'input',
          prop: 'name'
        },
        {
          label: '生成时间',
          type: 'date',
          prop: 'date'
        }
      ],
      columns: [
        {
          label: '生产批次',
          prop: 'name'
        },
        {
          label: '设备数量',
          prop: 'number'
        },
        {
          label: '生成时间',
          prop: 'createTime',
          type: 'slot',
          slotName: 'createTime'
        },
        {
          label: '使用状态',
          prop: 'status',
          type: 'slot',
          slotName: 'status'
        },
        {
          label: '操作',
          prop: 'operation',
          type: 'slot',
          slotName: 'operation',
          width: '180'
        }
      ]
    }
  },
  methods: {
    init() {
      this.$refs.table.init()
    },
    handleWatch(row) {
      const params = {
        name: row.name
      }
      this.$router.push({ name: 'equipment-list', params })
    },
    handleBatch() {
      this.$refs.addBatch.open()
    },
    handleSearch(val) {
      const params = {
        ...val
      }
      if (val.beginTime) {
        params.startTime = val.beginTime
        delete params.beginTime
      }
      this.$refs.table.search(params)
    }
  }
}
</script>
